import { render, staticRenderFns } from "./PlayersPendings.vue?vue&type=template&id=42891550&"
import script from "./PlayersPendings.vue?vue&type=script&lang=js&"
export * from "./PlayersPendings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports